import React from 'react';

const PharmacyReportPage = React.lazy(() => import('pages/PharmacyReport/PharmacyReportPage'));

const reports = [
  ['overview', 'APP_PHARMACY_REPORT_OVERVIEW_VIEW', 'Tổng quan nhà thuốc'],
  ['sales-detail', 'APP_PHARMACY_REPORT_SALES_VIEW', 'Chi tiết bán thuốc'],
  ['paid-pending-dispensing', 'APP_PHARMACY_REPORT_PENDING_DISPENSING_VIEW', 'Đã thu tiền, chờ phát thuốc'],
  ['process-reconciliation', 'APP_PHARMACY_REPORT_PROCESS_RECONCILIATION_VIEW', 'Đối soát quy trình'],
  ['payment-reconciliation', 'APP_PHARMACY_REPORT_PAYMENT_RECONCILIATION_VIEW', 'Đối soát thanh toán'],
  ['gross-profit', 'APP_PHARMACY_REPORT_GROSS_PROFIT_VIEW', 'Doanh thu và lãi gộp'],
  ['inventory-lot-expiry', 'APP_PHARMACY_REPORT_INVENTORY_LOT_VIEW', 'Tồn kho theo lô, hạn dùng'],
  ['stock-card', 'APP_PHARMACY_REPORT_STOCK_CARD_VIEW', 'Thẻ kho'],
  ['inventory-risk', 'APP_PHARMACY_REPORT_INVENTORY_RISK_VIEW', 'Rủi ro tồn kho'],
  ['shortage-purchase-request', 'APP_PHARMACY_REPORT_SHORTAGE_PURCHASE_VIEW', 'Thiếu thuốc và yêu cầu mua'],
  ['purchase-reconciliation', 'APP_PHARMACY_REPORT_PURCHASE_RECONCILIATION_VIEW', 'Đối soát nhập thuốc'],
  ['supplier-performance', 'APP_PHARMACY_REPORT_SUPPLIER_PERFORMANCE_VIEW', 'Hiệu quả nhà cung cấp'],
];

export default reports.map(([code, permission, name]) => ({
  path: `/pharmacy-reports/${code}`,
  exact: true,
  name,
  function: permission,
  component: PharmacyReportPage,
}));
